function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M2563.891 215.96l-160.446 1.689h-116.153c-6.444 0-44.651 92.677-50.942 92.677s1.841-297.826-4.6-297.826-48.182 203.46-54.014 203.46H1708.35s-1511.36-.422-1708.348 0",
  fill: "none",
  stroke: "#09bfec",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 25,
  opacity: 0.14
});

function SvgPulseLine3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2564.023,
    height: 322.826,
    viewBox: "0 0 2564.023 322.826"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNTY0LjAyMyIgaGVpZ2h0PSIzMjIuODI2IiB2aWV3Qm94PSIwIDAgMjU2NC4wMjMgMzIyLjgyNiI+PHBhdGggZD0iTTEwNjQuNzIzLDcxMy43MTEsOTA0LjI3Nyw3MTUuNEg3ODguMTI0Yy02LjQ0NCwwLTQ0LjY1MSw5Mi42NzctNTAuOTQyLDkyLjY3N3MxLjg0MS0yOTcuODI2LTQuNi0yOTcuODI2UzY4NC40LDcxMy43MTEsNjc4LjU2OCw3MTMuNzExSDIwOS4xODJzLTE1MTEuMzYtLjQyMi0xNzA4LjM0OCwwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNDk5LjE2OCAtNDk3Ljc1MSkiIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzA5YmZlYyIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2Utd2lkdGg9IjI1IiBvcGFjaXR5PSIwLjE0Ii8+PC9zdmc+";
export { SvgPulseLine3 as ReactComponent };